import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
  return request({
    url: "/alarmSet/commonAlarmSet/findByPage",
    method: "post",
    headers: { type: "json" },
    data
  });
}

/**
 * 批量删除报警设置
 * @param {*} data
 */
export function FetchDeleteCommonAlarmSetBatch(data) {
  return request({
    url: "/alarmSet/commonAlarmSet/deleteCommonAlarmSetBatch",
    method: "post",
    data
  });
}

/**
 * 初始化车辆树
 */
export function FetchFindVehicleTree() {
  return request({
    url: "/tms/vehicleInfo/getOrgVehicleTree",
    method: "post"
  });
}

/**
 * 保存停车报警设置
 */
export function FetchSaveStopAlarmSet(data) {
  return request({
    url: "/alarmSet/stopAlarmSet/saveStopAlarmSet",
    method: "post",
    headers: { type: "json" },
    data
  });
}

/**
 * 根据ID获取停车报警设置
 */
export function FetchFindStopAlarmById(data) {
  return request({
    url: "/alarmSet/stopAlarmSet/getStopAlarmSetById",
    method: "post",
    data
  });
}

/**
 * 修改停车报警设置
 */
export function FetchUpdateStopAlarmSet(data) {
  return request({
    url: "/alarmSet/stopAlarmSet/updateStopAlarmSet",
    method: "post",
    headers: { type: "json" },
    data
  });
}

/**
 * 保存疲劳驾驶报警设置
 */
export function FetchSaveFatigueDriverAlarmSet(data) {
  return request({
    url: "/alarmSet/fatigueDriverAlarmSet/saveFatigueDriverAlarmSet",
    method: "post",
    headers: { type: "json" },
    data
  });
}

/**
 * 根据ID获取疲劳驾驶报警设置
 */
export function FetchFindFatigueDriverAlarmById(data) {
  return request({
    url: "/alarmSet/fatigueDriverAlarmSet/getFatigueDriverAlarmSetById",
    method: "post",
    data
  });
}

/**
 * 修改疲劳驾驶报警设置
 */
export function FetchUpdateFatigueDriverAlarmSet(data) {
  return request({
    url: "/alarmSet/fatigueDriverAlarmSet/updateFatigueDriverAlarmSet",
    method: "post",
    headers: { type: "json" },
    data
  });
}

/**
 * 保存劫警设置
 */
export function FetchSaveLootAlarmSet(data) {
  return request({
    url: "/alarmSet/lootAlarmSet/saveLootAlarmSet",
    method: "post",
    headers: { type: "json" },
    data
  });
}

/**
 * 根据ID获取劫警设置
 */
export function FetchFindLootAlarmById(data) {
  return request({
    url: "/alarmSet/lootAlarmSet/getLootAlarmSetById",
    method: "post",
    data
  });
}

/**
 * 修改劫警设置
 */
export function FetchUpdateLootAlarmSet(data) {
  return request({
    url: "/alarmSet/lootAlarmSet/updateLootAlarmSet",
    method: "post",
    headers: { type: "json" },
    data
  });
}

/**
 * 保存超速报警设置
 */
export function FetchSaveOverSpeedAlarmSet(data) {
  return request({
    url: "/alarmSet/overSpeedAlarmSet/saveOverSpeedAlarmSet",
    method: "post",
    headers: { type: "json" },
    data
  });
}

/**
 * 根据ID获取超速报警设置
 */
export function FetchFindOverSpeedAlarmById(data) {
  return request({
    url: "/alarmSet/overSpeedAlarmSet/getOverSpeedAlarmSetById",
    method: "post",
    data
  });
}

/**
 * 修改超速报警设置
 */
export function FetchUpdateOverSpeedAlarmSet(data) {
  return request({
    url: "/alarmSet/overSpeedAlarmSet/updateOverSpeedAlarmSet",
    method: "post",
    headers: { type: "json" },
    data
  });
}
